import RangeSlider from 'components/range-slider';

/**
 * Модуль инициализирует слайдеры исходя из опций из скрипта и данных от бэка. Работает в vue.js
 * @param {object} refs - все this.$refs модуля
 * @param {object} data - данные от бэкенда по всем слайдерам
 */
export default (refs, data) => {
    if (refs.sliderPrice) {
        const sliderPrice = new RangeSlider();

        sliderPrice.init({
            wrapper     : refs.sliderPrice.$el,
            outerOptions: {
                type : 'double',
                step : 10000,
                digit: true,
                ...data.price
            }
        });
    }

    if (refs.sliderArea) {
        const sliderArea = new RangeSlider();

        sliderArea.init({
            wrapper     : refs.sliderArea.$el,
            outerOptions: {
                type    : 'double',
                step    : 1,
                validate: 'number_decimal',
                ...data.area
            }
        });
    }

    if (refs.sliderFloors) {
        const sliderFloors = new RangeSlider();

        sliderFloors.init({
            wrapper     : refs.sliderFloors.$el,
            outerOptions: {
                type    : 'double',
                step    : 1,
                validate: 'number',
                ...data.floors
            }
        });
    }
};

